import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Scrollbars } from "react-custom-scrollbars";
import moment from "moment";
import Bubble from "./bubble/BubbleWithStore";

export default class ApprovalList extends Component {
  static propTypes = {
    isPendingTab: PropTypes.bool,
    agentId: PropTypes.number,
    pendingStreams: PropTypes.array
  };

  static defaultProps = {
    pendingStreams: []
  };

  render() {
    const { isPendingTab, agentId, pendingStreams } = this.props;

    // prepare pending stream data
    const streams = [];
    if (pendingStreams.length > 0) {
      for (const stream of pendingStreams) {
        const streamStatus = stream.escalation.status;
        const streamEscalatedToId = stream.escalation.escalatedTo.id;

        // filter stream
        if (streamStatus === "APPROVED") {
          // never show approved pending stream
          continue;
        } else if (
          isPendingTab &&
          (streamStatus !== "ON_PROGRESS" || streamEscalatedToId !== agentId)
        ) {
          // on pending tab, show on progress pending stream for this agent only
          continue;
        } else {
          // collect streams
          streams.push({
            id: stream.id,
            content: stream.content,
            status: stream.escalation.status,
            time: moment(stream.dateCreated),
            avatar: stream.createdBy.displayPicture,
            imageUrl: null,
            rejectionNote: stream.noteClose ? stream.noteClose.content : null
          });
        }
      }
    }

    // sort stream by time, latest on top
    streams.sort((a, b) => b.time - a.time);

    // only show list if got pending streams
    return streams.length === 0 ? null : (
      <Wrapper doubleHeight={isPendingTab}>
        <Title>Need Approval</Title>
        <Scrollbars>
          <Padding>
            {streams.map(stream => {
              return <Bubble key={stream.id} {...stream} />;
            })}
          </Padding>
        </Scrollbars>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  border-top: dashed 1px ${props => props.theme.panelBorder};
  flex: ${props => (props.doubleHeight ? 2 : 1)};
`;
const Padding = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
`;
const Title = styled.div`
  position: fixed;
  margin-top: -10px;
  font-size: 0.8rem;
  color: ${props => props.theme.uiText};
  align-self: center;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/approval-list/ApprovalList.js